import request from '@/config/request'

export default {
    searchMyCoupon: function (data) {
        return request({
            url: '/asset/mycoupon/searchmycoupon',
            method: 'post',
            params: data
        })
    },
    searchListMyCoupon: function (customerCode, status) {
        return request({
            url: '/asset/mycoupon/searchlistmycoupon',
            method: 'post',
            params: {
                customercode: customerCode,
                status: status,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/asset/mycoupon.js